import { render } from "./emergencylist.vue?vue&type=template&id=3cd7b442&scoped=true"
import script from "./emergencylist.vue?vue&type=script&lang=js"
export * from "./emergencylist.vue?vue&type=script&lang=js"

import "./emergencylist.vue?vue&type=style&index=0&id=3cd7b442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd7b442"]])

export default __exports__